import Service from 'additiv-services/services/core/service';
import { getQueryStringByObject } from 'additiv-services/utils/queryUtils';
import { getCreditServiceUrl, getCustomServiceLayerHeader } from 'additiv-services/setup';
import {
    CREDIT_SERVICE_LAYER_SERVICES,
    CUSTOM_SERVICE_LAYER_SERVICES,
    getCustomServiceLayerBaseUrl,
} from '../constants';

class CustomReports extends Service {
    static generateReport({ data }) {
        return Service.postRequest(
            `${getCustomServiceLayerBaseUrl(CUSTOM_SERVICE_LAYER_SERVICES.DEFAULT)}portfolio-statement-report`,
            data,
            {
                isSecure: true,
                axiosSetup: { headers: getCustomServiceLayerHeader() },
            },
        );
    }

    static getReportsStartDate(params) {
        const queryString = getQueryStringByObject(params);

        return Service.getRequest(
            `${getCustomServiceLayerBaseUrl(CUSTOM_SERVICE_LAYER_SERVICES.DOCUMENTS)}/statement-min-start-date?${queryString}`,
            {
                isSecure: true,
                axiosSetup: { headers: getCustomServiceLayerHeader() },
            },
        );
    }

    static getCreditMaproReport({ from, to }) {
        return Service.postRequest(
            `${getCreditServiceUrl(CREDIT_SERVICE_LAYER_SERVICES.DEFAULT)}reports/mapro`,
            {
                startDate: from,
                endDate: to,
            },
            {
                isSecure: true,
                axiosSetup: {
                    headers: getCustomServiceLayerHeader(),
                    responseType: 'blob',
                },
            },
        );
    }
}

export default CustomReports;
